<button
  type="button"
  class="al-icon-button page-help__button"
  [nbPopover]="content"
  nbPopoverTrigger="click"
  [nbPopoverPlacement]="placement"
  [attr.aria-label]="'charts.labels.help' | translate"
>
  <nb-icon icon="question-mark-circle-outline"></nb-icon>
</button>

<ng-template #content>
  <div class="page-help-popover"><ng-content></ng-content></div>
</ng-template>
